import UpgradeWrapper from './UpgradeWrapper';

export default UpgradeWrapper;
